export default function viewportChange() {
  const ua = navigator.userAgent;/* eslint-env browser */
  const viewport = document.querySelectorAll("[name='viewport']");
  if ( ( ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 ) && ua.indexOf('Mobile') > 0) {
    viewport[ 0 ].setAttribute('content', 'width=device-width, initial-scale=1');
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    viewport[ 0 ].setAttribute('content', 'width=1400');
  }
}
